//Get all tickets for list
const TICKET_LIST_DATA = {
  TICKET_LIST_DATA_LOAD: "TICKET_LIST_DATA_LOAD",
  TICKET_LIST_DATA_SUCCESS: "TICKET_LIST_DATA_SUCCESS",
  TICKET_LIST_DATA_FAIL: "TICKET_LIST_DATA_FAIL",
};
const TICKET_LIST_DATA_GET_API = "tickets/ticket/AdminTickets";

//Get ticket by id
const TICKET_DETAILS_DATA = {
  TICKET_DETAILS_DATA_LOAD: "TICKET_DETAILS_DATA_LOAD",
  TICKET_DETAILS_DATA_SUCCESS: "TICKET_DETAILS_DATA_SUCCESS",
  TICKET_DETAILS_DATA_FAIL: "TICKET_DETAILS_DATA_FAIL",
};
const TICKET_DETAILS_DATA_GET_API = "tickets/ticket/AdminTickets/";

//Get insight by id
const TICKET_INSIGHT_DETAILS_DATA = {
  TICKET_INSIGHT_DETAILS_DATA_LOAD: "TICKET_INSIGHT_DETAILS_DATA_LOAD",
  TICKET_INSIGHT_DETAILS_DATA_SUCCESS: "TICKET_INSIGHT_DETAILS_DATA_SUCCESS",
  TICKET_INSIGHT_DETAILS_DATA_FAIL: "TICKET_INSIGHT_DETAILS_DATA_FAIL",
};
const TICKET_INSIGHT_DETAILS_DATA_GET_API = "tickets/ticket/";

//Get article by id
const TICKET_ARTICLE_DATA = {
  TICKET_ARTICLE_DATA_LOAD: "TICKET_ARTICLE_DATA_LOAD",
  TICKET_ARTICLE_DATA_SUCCESS: "TICKET_ARTICLE_DATA_SUCCESS",
  TICKET_ARTICLE_DATA_FAIL: "TICKET_ARTICLE_DATA_FAIL",
};
const TICKET_ARTICLE_DATA_GET_API = "tickets/article/ByConfigId/";

//Save ticket details 
const TICKET_DETAILS_ADD_DATA = {
  TICKET_DETAILS_ADD_DATA_LOAD: "TICKET_DETAILS_ADD_DATA_LOAD",
  TICKET_DETAILS_ADD_DATA_SUCCESS: "TICKET_DETAILS_ADD_DATA_SUCCESS",
  TICKET_DETAILS_ADD_DATA_FAIL: "TICKET_DETAILS_ADD_DATA_FAIL",
};
const TICKET_DETAILS_ADD_DATA_API = "tickets/ticket/AdminTickets/";

//Save ticket messages 
const TICKET_MESSAGE_ADD_DATA = {
  TICKET_MESSAGE_ADD_DATA_LOAD: "TICKET_MESSAGE_ADD_DATA_LOAD",
  TICKET_MESSAGE_ADD_DATA_SUCCESS: "TICKET_MESSAGE_ADD_DATA_SUCCESS",
  TICKET_MESSAGE_ADD_DATA_FAIL: "TICKET_MESSAGE_ADD_DATA_FAIL",
};
const TICKET_MESSAGE_ADD_DATA_API = "tickets/ticket/message";

//Save ticket solution
const TICKET_SOLUTION_ADD_DATA = {
  TICKET_SOLUTION_ADD_DATA_LOAD: "TICKET_SOLUTION_ADD_DATA_LOAD",
  TICKET_SOLUTION_ADD_DATA_SUCCESS: "TICKET_SOLUTION_ADD_DATA_SUCCESS",
  TICKET_SOLUTION_ADD_DATA_FAIL: "TICKET_SOLUTION_ADD_DATA_FAIL",
};
const TICKET_SOLUTION_ADD_DATA_API = "tickets/ticket/AdminTickets/";


// Get user filter data
const GET_USER_TICKET_FILTER_DATA = {
  TICKET_FILTER_DETAILS_DATA_LOAD: "TICKET_FILTER_DETAILS_DATA_LOAD",
  TICKET_FILTER_DETAILS_DATA_SUCCESS: "TICKET_FILTER_DETAILS_DATA_SUCCESS",
  TICKET_FILTER_DETAILS_DATA_FAIL: "TICKET_FILTER_DETAILS_DATA_FAIL",
};

// Save user filter data
const USER_TICKET_FILTER_ADD_DATA = {
  TICKET_FILTER_ADD_DATA_LOAD: "TICKET_FILTER_ADD_DATA_LOAD",
  TICKET_FILTER_ADD_DATA_SUCCESS: "TICKET_FILTER_ADD_DATA_SUCCESS",
  TICKET_FILTER_ADD_DATA_FAIL: "TICKET_FILTER_ADD_DATA_FAIL",
};

// filetr APIs
const USER_TICKET_FILTER_ADD_DATA_API = "tickets/ticket/user-filters";

const USER_TICKET_FILTER_GET_DATA_API = "tickets/ticket/user-filters?filter_type=";

  //Get cate by id
const WORKFLOW_DETAILS_DATA = {
  WORKFLOW_DETAILS_DATA_LOAD: "WORKFLOW_DETAILS_DATA_LOAD",
  WORKFLOW_DETAILS_DATA_SUCCESS: "WORKFLOW_DETAILS_DATA_SUCCESS",
  WORKFLOW_DETAILS_DATA_FAIL: "WORKFLOW_DETAILS_DATA_FAIL",
};
const WORKFLOW_DETAILS_DATA_GET_API = "tickets/workflow/";

// DELETE user filter data
 const USER_TICKET_FILTER_DELETE_DATA = {
  TICKET_FILTER_DELETE_DATA_LOAD: "TICKET_FILTER_DELETE_DATA_LOAD",
  TICKET_FILTER_DELETE_DATA_SUCCESS: "TICKET_FILTER_DELETE_DATA_SUCCESS",
  TICKET_FILTER_DELETE_DATA_FAIL: "TICKET_FILTER_DELETE_DATA_FAIL",
};

// Base API for delete (id will be appended in saga)
 const USER_TICKET_FILTER_DELETE_DATA_API =
  "tickets/ticket/user-filters/";

export const ADMIN_TICKETS = {
  QUERY_LOAD: "ADMIN_TICKETS_QUERY_LOAD",
  QUERY_SUCCESS: "ADMIN_TICKETS_QUERY_SUCCESS",
  QUERY_FAIL: "ADMIN_TICKETS_QUERY_FAIL",

  ROWCOUNT_LOAD: "ADMIN_TICKETS_ROWCOUNT_LOAD",
  ROWCOUNT_SUCCESS: "ADMIN_TICKETS_ROWCOUNT_SUCCESS",
  ROWCOUNT_FAIL: "ADMIN_TICKETS_ROWCOUNT_FAIL",
};

const QUERY_API = "tickets/ticket/adminTickets/query";
const ROWCOUNT_API = "tickets/ticket/adminTickets/rowcount";

const MESSAGE_TEMPLATE_DROPDOWN = {
  MESSAGE_TEMPLATE_DROPDOWN_LOAD: "MESSAGE_TEMPLATE_DROPDOWN_LOAD",
  MESSAGE_TEMPLATE_DROPDOWN_SUCCESS: "MESSAGE_TEMPLATE_DROPDOWN_SUCCESS",
  MESSAGE_TEMPLATE_DROPDOWN_FAIL: "MESSAGE_TEMPLATE_DROPDOWN_FAIL",
};

const MESSAGE_TEMPLATE_DROPDOWN_API = "tickets/message-templates";

// Save ticket filter data
const TICKET_FILTER_DATA = {
  TICKET_FILTER_DATA_LOAD: "TICKET_FILTER_DATA_LOAD",
  TICKET_FILTER_DATA_SUCCESS: "TICKET_FILTER_DATA_SUCCESS",
  TICKET_FILTER_DATA_FAIL: "TICKET_FILTER_DATA_FAIL",
};
const TICKET_FILTER_DATA_API = "tickets/ticket/user-filters/preference";

//Save Workflow details 
const WORKFLOW_DETAILS_ADD_DATA = {
  WORKFLOW_DETAILS_ADD_DATA_LOAD: "WORKFLOW_DETAILS_ADD_DATA_LOAD",
  WORKFLOW_DETAILS_ADD_DATA_SUCCESS: "WORKFLOW_DETAILS_ADD_DATA_SUCCESS",
  WORKFLOW_DETAILS_ADD_DATA_FAIL: "WORKFLOW_DETAILS_ADD_DATA_FAIL",
};
const WORKFLOW_DETAILS_ADD_DATA_API = (workflowId, ticketId) => `tickets/workflow/${workflowId}/ticket/${ticketId}`;

// Delete Ticket
const TICKET_DELETE_DATA = {
  TICKET_DELETE_LOAD: "TICKET_DELETE_LOAD",
  TICKET_DELETE_SUCCESS: "TICKET_DELETE_SUCCESS",
  TICKET_DELETE_FAIL: "TICKET_DELETE_FAIL",
};
const TICKET_DELETE_API = "tickets/ticket/";
// Delete cate
const WORKFLOW_DELETE_DATA = {
  WORKFLOW_DELETE_LOAD: "WORKFLOW_DELETE_LOAD",
  WORKFLOW_DELETE_SUCCESS: "WORKFLOW_DELETE_SUCCESS",
  WORKFLOW_DELETE_FAIL: "WORKFLOW_DELETE_FAIL",
};
const WORKFLOW_DELETE_API = "tickets/workflow/";

// bulk update
const TICKET_BULK_UPDATE_DATA = {
  TICKET_BULK_UPDATE_LOAD: "TICKET_BULK_UPDATE_LOAD",
  TICKET_BULK_UPDATE_SUCCESS: "TICKET_BULK_UPDATE_SUCCESS",
  TICKET_BULK_UPDATE_FAIL: "TICKET_BULK_UPDATE_FAIL",
};
const TICKET_BULK_UPDATE_API = "tickets/ticket/bulk-update";

// Get error logs
const TICKET_ERROR_LOG_DATA = {
  TICKET_ERROR_LOG_DATA_LOAD: "TICKET_ERROR_LOG_DATA_LOAD",
  TICKET_ERROR_LOG_DATA_SUCCESS: "TICKET_ERROR_LOG_DATA_SUCCESS",
  TICKET_ERROR_LOG_DATA_FAIL: "TICKET_ERROR_LOG_DATA_FAIL",
};
const TICKET_ERROR_LOG_DATA_GET_API = "tickets/ticket/error-logs";

// Get email exec logs
const TICKET_EMAIL_EXECUTION_LOG_DATA = {
  TICKET_EMAIL_EXECUTION_LOG_DATA_LOAD: "TICKET_EMAIL_EXECUTION_LOG_DATA_LOAD",
  TICKET_EMAIL_EXECUTION_LOG_DATA_SUCCESS: "TICKET_EMAIL_EXECUTION_LOG_DATA_SUCCESS",
  TICKET_EMAIL_EXECUTION_LOG_DATA_FAIL: "TICKET_EMAIL_EXECUTION_LOG_DATA_FAIL",
};
const TICKET_EMAIL_EXECUTION_LOG_DATA_GET_API = "tickets/email-rules/execution-logs";

//Get all tickets dashboard metrics
const TICKET_DASHBOARD_METRIC_DATA = {
  TICKET_DASHBOARD_METRIC_DATA_LOAD: "TICKET_DASHBOARD_METRIC_DATA_LOAD",
  TICKET_DASHBOARD_METRIC_DATA_SUCCESS: "TICKET_DASHBOARD_METRIC_DATA_SUCCESS",
  TICKET_DASHBOARD_METRIC_DATA_FAIL: "TICKET_DASHBOARD_METRIC_DATA_FAIL",
};
const TICKET_DASHBOARD_METRIC_DATA_GET_API = "tickets/metrics/tickets";

// Save ticket attachment (standalone upload, fires on drop/select)
const TICKET_ATTACHMENT_ADD_DATA = {
  TICKET_ATTACHMENT_ADD_DATA_LOAD: "TICKET_ATTACHMENT_ADD_DATA_LOAD",
  TICKET_ATTACHMENT_ADD_DATA_SUCCESS: "TICKET_ATTACHMENT_ADD_DATA_SUCCESS",
  TICKET_ATTACHMENT_ADD_DATA_FAIL: "TICKET_ATTACHMENT_ADD_DATA_FAIL",
};
const TICKET_ATTACHMENT_ADD_DATA_API = (ticketId) => `tickets/ticket/${ticketId}/attachments`;

// Delete ticket attachment
const TICKET_ATTACHMENT_DELETE_DATA = {
  TICKET_ATTACHMENT_DELETE_LOAD: "TICKET_ATTACHMENT_DELETE_LOAD",
  TICKET_ATTACHMENT_DELETE_SUCCESS: "TICKET_ATTACHMENT_DELETE_SUCCESS",
  TICKET_ATTACHMENT_DELETE_FAIL: "TICKET_ATTACHMENT_DELETE_FAIL",
};
const TICKET_ATTACHMENT_DELETE_API = (ticketId, attachmentId) => `tickets/ticket/${ticketId}/attachments/${attachmentId}`;


export {
  TICKET_LIST_DATA,
  TICKET_LIST_DATA_GET_API,
  TICKET_DETAILS_DATA,
  TICKET_DETAILS_DATA_GET_API,
  TICKET_INSIGHT_DETAILS_DATA,
  TICKET_INSIGHT_DETAILS_DATA_GET_API,
  TICKET_ARTICLE_DATA,
  TICKET_ARTICLE_DATA_GET_API,
  TICKET_DETAILS_ADD_DATA,
  TICKET_DETAILS_ADD_DATA_API,
  TICKET_MESSAGE_ADD_DATA,
  TICKET_MESSAGE_ADD_DATA_API,
  TICKET_SOLUTION_ADD_DATA,
  TICKET_SOLUTION_ADD_DATA_API,
  USER_TICKET_FILTER_ADD_DATA,
  GET_USER_TICKET_FILTER_DATA,
  USER_TICKET_FILTER_ADD_DATA_API,
  USER_TICKET_FILTER_GET_DATA_API,
  USER_TICKET_FILTER_DELETE_DATA,
  USER_TICKET_FILTER_DELETE_DATA_API,
  QUERY_API,
  ROWCOUNT_API,
  WORKFLOW_DETAILS_DATA,
  WORKFLOW_DETAILS_DATA_GET_API,
  MESSAGE_TEMPLATE_DROPDOWN,
  MESSAGE_TEMPLATE_DROPDOWN_API,
  TICKET_FILTER_DATA,
  TICKET_FILTER_DATA_API,
  WORKFLOW_DETAILS_ADD_DATA,
  WORKFLOW_DETAILS_ADD_DATA_API,
  TICKET_DELETE_DATA,
  TICKET_DELETE_API,
  WORKFLOW_DELETE_DATA,
  WORKFLOW_DELETE_API,
  TICKET_BULK_UPDATE_DATA,
  TICKET_BULK_UPDATE_API,
  TICKET_ERROR_LOG_DATA,
  TICKET_ERROR_LOG_DATA_GET_API,
  TICKET_EMAIL_EXECUTION_LOG_DATA,
  TICKET_EMAIL_EXECUTION_LOG_DATA_GET_API,
  TICKET_DASHBOARD_METRIC_DATA,
  TICKET_DASHBOARD_METRIC_DATA_GET_API,
  TICKET_ATTACHMENT_ADD_DATA,
  TICKET_ATTACHMENT_ADD_DATA_API,
  TICKET_ATTACHMENT_DELETE_API,
  TICKET_ATTACHMENT_DELETE_DATA,
};